import { render, staticRenderFns } from "./PropertyBoolean.vue?vue&type=template&id=84f285f8&"
import script from "./PropertyBoolean.vue?vue&type=script&lang=js&"
export * from "./PropertyBoolean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports